var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbotLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 16,
    fill: "url(#paint0_linear_1001_9946)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4997 25.334C19.5792 25.334 18.833 26.0802 18.833 27.0007C18.833 27.9211 19.5792 28.6673 20.4997 28.6673C21.4201 28.6673 22.1663 27.9211 22.1663 27.0007C22.1663 26.0802 21.4201 25.334 20.4997 25.334ZM17.1663 27.0007C17.1663 25.1597 18.6587 23.6673 20.4997 23.6673C22.3406 23.6673 23.833 25.1597 23.833 27.0007C23.833 28.8416 22.3406 30.334 20.4997 30.334C18.6587 30.334 17.1663 28.8416 17.1663 27.0007Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4997 25.334C34.5792 25.334 33.833 26.0802 33.833 27.0007C33.833 27.9211 34.5792 28.6673 35.4997 28.6673C36.4202 28.6673 37.1663 27.9211 37.1663 27.0007C37.1663 26.0802 36.4202 25.334 35.4997 25.334ZM32.1663 27.0007C32.1663 25.1597 33.6587 23.6673 35.4997 23.6673C37.3406 23.6673 38.833 25.1597 38.833 27.0007C38.833 28.8416 37.3406 30.334 35.4997 30.334C33.6587 30.334 32.1663 28.8416 32.1663 27.0007Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6663 32.834C25.1266 32.834 25.4997 33.2071 25.4997 33.6673L25.5002 33.6719C25.5002 33.6719 25.502 33.6795 25.5053 33.6876C25.512 33.704 25.5281 33.7349 25.5645 33.7779C25.6405 33.8677 25.7832 33.9844 26.0153 34.1005C26.4801 34.3329 27.1805 34.5006 27.9997 34.5006C28.8188 34.5006 29.5192 34.3329 29.984 34.1005C30.2162 33.9844 30.3588 33.8677 30.4348 33.7779C30.4712 33.7349 30.4873 33.704 30.494 33.6876C30.4974 33.6795 30.4991 33.6719 30.4991 33.6719L30.4997 33.6673C30.4997 33.2071 30.8728 32.834 31.333 32.834C31.7932 32.834 32.1663 33.2071 32.1663 33.6673C32.1663 34.6132 31.4212 35.2453 30.7294 35.5912C29.9877 35.962 29.0215 36.1673 27.9997 36.1673C26.9779 36.1673 26.0116 35.962 25.27 35.5912C24.5782 35.2453 23.833 34.6132 23.833 33.6673C23.833 33.2071 24.2061 32.834 24.6663 32.834Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6663 16.1673V19.5007H21.333V16.1673C21.333 15.7071 20.9599 15.334 20.4997 15.334C20.0394 15.334 19.6663 15.7071 19.6663 16.1673V19.5007H17.9997C15.6985 19.5007 13.833 21.3661 13.833 23.6673V35.334C13.833 37.6352 15.6985 39.5006 17.9997 39.5006H37.9997C40.3009 39.5006 42.1663 37.6352 42.1663 35.334V23.6673C42.1663 21.3661 40.3009 19.5007 37.9997 19.5007H36.333V16.1673C36.333 15.7071 35.9599 15.334 35.4997 15.334C35.0394 15.334 34.6663 15.7071 34.6663 16.1673ZM17.9997 21.1673C16.619 21.1673 15.4997 22.2866 15.4997 23.6673V35.334C15.4997 36.7147 16.619 37.834 17.9997 37.834H37.9997C39.3804 37.834 40.4997 36.7147 40.4997 35.334V23.6673C40.4997 22.2866 39.3804 21.1673 37.9997 21.1673H17.9997Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1001_9946",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotLogo);
export default __webpack_public_path__ + "static/media/chatbot-logo.cfc6d5c22555eb178607dccee0426153.svg";
export { ForwardRef as ReactComponent };